import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { AppShell } from '../components/layout/AppShell';
import { PageBody } from '../components/layout/PageBody';
import { EmptyState } from '../components/common/EmptyState';

export function NotFoundPage() {
  return (
    <AppShell title="Page not found" subtitle="This link does not go anywhere">
      <PageBody>
        <EmptyState
          title="This page isn’t available"
          description="The link may be old, or that story was taken down."
          action={
            <Button
              component={RouterLink}
              to="/"
              replace
              variant="contained"
              color="secondary"
            >
              Go to feed
            </Button>
          }
        />
      </PageBody>
    </AppShell>
  );
}
